import { URLConstructor } from '../../NonReact/utils/URLBuilder'
import { getAppV2APIBasePath } from '../../NonReact/constants/ApiConstants'
import { RouteID } from '../Components/Molecules/Header/Types/Types'

export const routePath = (routeID: RouteID): string => `/${routeID}`

export const AUTH_ROUTE_PATH: string = routePath(RouteID.AUTH)
export const CHANGE_PASSWORD_ROUTE_PATH: string = routePath(RouteID.CHANGE_PASSWORD)
export const MFA_ROUTE_PATH: string = routePath(RouteID.MFA)
export const TERMS_AND_CONDITIONS_ROUTE_PATH: string = routePath(RouteID.TERMS_AND_CONDITIONS)
export const TEAMS_AUTH_ROUTE_PATH: string = routePath(RouteID.TEAMS_AUTH)
export const INSIGHTS_ROUTE_PATH: URLConstructor = getAppV2APIBasePath().appendPathParams(RouteID.INSIGHTS)
export const PRESENCE_URL: URLConstructor = getAppV2APIBasePath().appendPathParams(RouteID.PRESENCE)

export const getAuthURL = (): URLConstructor => getAppV2APIBasePath().appendPathParams(RouteID.AUTH)

export const getChangeLanguageURL = (): URLConstructor =>
    getAppV2APIBasePath().appendPathParams(RouteID.CHANGE_LANGUAGE)

export const getChangePasswordURL = (): URLConstructor =>
    getAppV2APIBasePath().appendPathParams(RouteID.CHANGE_PASSWORD)

export const termsAndConditionsURL = (): URLConstructor =>
    getAppV2APIBasePath().appendPathParams(RouteID.TERMS_AND_CONDITIONS)

export const cookiePolicyURL = (): URLConstructor => getAppV2APIBasePath().appendPathParams(RouteID.COOKIE_POLICY)

export const privacyPolicyURL = (): URLConstructor => getAppV2APIBasePath().appendPathParams(RouteID.PRIVACY_POLICY)
